/**************************************************
 * Nombre:       ImagenesProducto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import foto from '../../../../Recursos/costal_cafe.png'
import saco from '../../../../Recursos/saco.png'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";

const ImagenesProducto = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const [imgs,setImgs]= useState([foto, saco])


    useEffect(() =>{


        let arr = []
        if (item && item.img){
            arr.push(item.img)
        }

        if (item.imgs){
            arr.push(...item.imgs)
        }

        if (arr.length > 0){
            setImgs(arr)
        }



    },[item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', pr:sCell ? 0 :  4}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: true,
                        pagination: false,
                        width: '100%',
                        drag: 'false',
                        interval: 5000,
                        noDrag: true,
                        perMove: 1,
                        type: 'fade'


                    }}
                >

                    {imgs.map((item, index) => {
                        return (
                            <SplideSlide key={`dqe${index}`}>
                                <img src={item} width={'100%'} height={'auto'}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>


        </Grid>
    )

}
export default ImagenesProducto

const items = [foto, foto, foto, foto]